import Movergrupos from "../Movergrupos";
import Removeradm from "../Removeradm";
import Removerparticipante from "../Removerparticipante";
import React, { useState, useRef } from "react";
import LogoCompleta from "../../../assets/logonotify1.png";
import LogoIcone from "../../../assets/notifyicone.png";
import "./Adicionar.css";
import {
  FaClipboardList,
  FaUser,
  FaUsers,
  FaCommentDots,
  FaPaperPlane,
  FaCheckCircle,
  FaUserEdit,
  FaImage,
  FaCog,
  FaUserPlus,
  FaUserMinus,
  FaUserTimes,
  FaExchangeAlt,
  FaEdit,
  FaMicrophone,
  FaVideo,
  FaPoll,
  FaAddressBook,
  FaCalendarAlt,
  FaFileAlt,
  FaLaughBeam,
  FaSmile,
} from "react-icons/fa";
import { FaTrash } from "react-icons/fa";
import { FaUpload } from "react-icons/fa";
import whatsappBgImg from "../../../assets/whatsapp-bg.png";
import PrivateMenuLeft from "../sections/Header/privateMenuLeft";
import PrivateMenuUp from "../sections/Header/privateMenuUp";
import Operacoes from "./Operacoes";
import ContasConectadas from "./ContasConectadas"; // Importe o novo componente
import Grupos from "./Grupos"; // Importe o novo componente
import Mensagem from "./Mensagem"; // Importe o componente Mensagem
import Mudanome from "../Mudanome";
import Mudadescricao from "../Mudadescricao";
import Mudaimagem from "../Mudaimagem";
import Mudaconfig from "../Mudaconfig";
import Entrarnogrupo from "../Entrarnogrupo";
import Adicionaradm from "../Adicionaradm";
import EtapaEnvio from "./EtapaEnvio"; // Importe o componente EtapaEnvio


const HEADER_HEIGHT = 56;
const notifyColor = "#51a197";

const etapas = ["Operação", "Conta", "Grupos", "Conteúdo", "Enviar"];

function extrairLink(texto) {
  const match = texto.match(/https?:\/\/[^\s]+/);
  return match ? match[0] : null;
}


import { useContext, useEffect } from "react";
import { OperacaoContext } from "../../../context/OperacaoContext";

const AdicionarOperacao = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Etapas
  // Se vier do editar, já começa na etapa de conteúdo
  const location = window.location && window.location.state ? window.location : undefined;
  let etapaInicial = 1;
  let idxEdicao = null;
  let modoEdicao = false;
  let selectedInitial = '';
  if (typeof window !== 'undefined' && window.history && window.history.state && window.history.state.usr) {
    const usr = window.history.state.usr;
    if (usr.etapa) etapaInicial = usr.etapa;
    if (usr.editar) modoEdicao = true;
    if (typeof usr.idx === 'number') idxEdicao = usr.idx;
    if (usr.selected) selectedInitial = usr.selected;
  }
  const [etapaAtual, setEtapaAtual] = useState(etapaInicial);
  const [selected, setSelected] = useState(selectedInitial);

  // Garante que ao entrar em modo edição, a opção marcada já fique selecionada na etapa de operações
  React.useEffect(() => {
    if (selectedInitial && selected !== selectedInitial) {
      setSelected(selectedInitial);
    }
  }, [selectedInitial]);
  const [contasSelecionadas, setContasSelecionadas] = useState([]);
  const [grupoPesquisa, setGrupoPesquisa] = useState("");
  const [mostrarGrupos, setMostrarGrupos] = useState(false);

  const [mensagem, setMensagem] = useState("");
  const [novoNome, setNovoNome] = useState("");
  const [mostrarPreview, setMostrarPreview] = useState(false);
  const [editando, setEditando] = useState(null);
  const [mostrarEmojis, setMostrarEmojis] = useState(false);
  const [mensagens, setMensagens] = useState([]);
  const [gruposSelecionados, setGruposSelecionados] = useState([]);
  const [contasIniciais, setContasIniciais] = useState([]);

  // Importa operações do contexto
  const { operacoes } = useContext(OperacaoContext) || { operacoes: [] };

  // Preenche todos os campos ao entrar ou voltar para a etapa de conteúdo em modo de edição
  useEffect(() => {
    if (modoEdicao && idxEdicao !== null && operacoes && operacoes[idxEdicao] && etapaAtual === 4) {
      const op = operacoes[idxEdicao];
      // Preenche mensagens (texto, áudio, etc)
      if (op.mensagens) setMensagens(op.mensagens);
      if (op.mensagem) setMensagem(op.mensagem);
      if (op.gruposSelecionados) setGruposSelecionados(op.gruposSelecionados);
      if (op.contasSelecionadas) setContasSelecionadas(op.contasSelecionadas);
      if (typeof op.mencionarTodos !== 'undefined') setMencionarTodos(op.mencionarTodos);
      if (typeof op.envioTemporario !== 'undefined') setEnvioTemporario(op.envioTemporario);
      if (typeof op.velocidade !== 'undefined') setVelocidade(op.velocidade);
      if (typeof op.dataHora !== 'undefined') setDataHora && setDataHora(op.dataHora); // se existir esse estado
      setEditando(idxEdicao);
    }
  }, [modoEdicao, idxEdicao, operacoes, etapaAtual]);

  // NOVOS HOOKS PARA O MODAL DE ÁUDIO
  const [modalAudioAberto, setModalAudioAberto] = useState(false);
  const [gravandoAudio, setGravandoAudio] = useState(false);
  const [audioBlob, setAudioBlob] = useState(null);
  const [audioUrl, setAudioUrl] = useState(null);
  const [audioErro, setAudioErro] = useState("");
  const [gravador, setGravador] = useState(null);
  const [tempoGravacao, setTempoGravacao] = useState(0);
  const timerRef = useRef(null);

  // Novos estados para mencionar todos, envio temporário e velocidade
  const [mencionarTodos, setMencionarTodos] = useState(null); // null, true, false
  const [envioTemporario, setEnvioTemporario] = useState("desativado");
  const [velocidade, setVelocidade] = useState("nenhum");

  // Estado para habilitar o botão "Próximo" na etapa de mensagem
  const [botaoProximoHabilitado, setBotaoProximoHabilitado] = useState(false);

  // Inicia a gravação de áudio
  const iniciarGravacao = async () => {
    setAudioErro("");
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new window.MediaRecorder(stream);
      let chunks = [];
      mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) chunks.push(e.data);
      };
      mediaRecorder.onstop = () => {
        const blob = new Blob(chunks, { type: "audio/mp3" });
        setAudioBlob(blob);
        setAudioUrl(URL.createObjectURL(blob));
        setGravador(null);
        clearInterval(timerRef.current);
      };
      setGravador(mediaRecorder);
      setAudioBlob(null);
      setAudioUrl(null);
      setTempoGravacao(0);
      setGravandoAudio(true);
      mediaRecorder.start();
      // Inicia o contador
      timerRef.current = setInterval(() => {
        setTempoGravacao((t) => t + 1);
      }, 1000);
    } catch (err) {
      setAudioErro("Não foi possível acessar o microfone.");
      console.error(err);
    }
  };

  // Para a gravação
  const pararGravacao = () => {
    if (gravador) gravador.stop();
    setGravandoAudio(false);
    clearInterval(timerRef.current);
  };

  const handleUploadAudio = (e) => {
    setAudioErro("");
    const file = e.target.files[0];
    if (file && file.type === "audio/mp3") {
      setAudioBlob(file);
      setAudioUrl(URL.createObjectURL(file));
    } else {
      setAudioErro("Apenas arquivos MP3 são permitidos.");
    }
  };

  const handleEnviarAudio = () => {
    if (audioBlob) {
      setMensagens([...mensagens, { tipo: "audio", url: audioUrl }]);
      setAudioBlob(null);
      setAudioUrl(null);
      setGravandoAudio(false);
      setModalAudioAberto(false);
      setTempoGravacao(0);
    }
  };

  // Fecha o modal e reseta tudo
  const fecharModalAudio = () => {
    setModalAudioAberto(false);
    setGravandoAudio(false);
    setAudioBlob(null);
    setAudioUrl(null);
    setAudioErro("");
    setTempoGravacao(0);
    clearInterval(timerRef.current);
  };


  const isMobile = window.innerWidth < 500;

  const contasConectadas = [
    {
      nome: "Suporte Pedro",
      foto: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    {
      nome: "Emerson",
      foto: "https://randomuser.me/api/portraits/men/33.jpg",
    },
    {
      nome: "Suporte 2",
      foto: "https://randomuser.me/api/portraits/men/34.jpg",
    },
  ];

  const todasSelecionadas =
    contasSelecionadas.length === contasConectadas.length;

  const handleSelecionarConta = (nome) => {
    const contaObj = contasConectadas.find((c) => c.nome === nome);
    const jaSelecionada = contasSelecionadas.some((c) => c.nome === nome);
    if (jaSelecionada) {
      setContasSelecionadas(contasSelecionadas.filter((c) => c.nome !== nome));
    } else {
      setContasSelecionadas([...contasSelecionadas, contaObj]);
    }
  };

  const handleSelecionarTodas = () => {
    if (todasSelecionadas) {
      setContasSelecionadas([]);
    } else {
      setContasSelecionadas([...contasConectadas]);
    }
  };

  const campanha = {
    nome: "SedAnest",
    capa:
      "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=facearea&w=56&h=56",
  };

  const gruposExemplo = [
    { nome: "Grupo 1", id: 1 },
    { nome: "Grupo 2", id: 2 },
    { nome: "Grupo 3", id: 3 },
    { nome: "Grupo 4", id: 4 },
    { nome: "Grupo 5", id: 5 },
  ];

  const gruposFiltrados = gruposExemplo.filter((g) =>
    g.nome.toLowerCase().includes(grupoPesquisa.toLowerCase())
  );

  const handleSelecionarGrupo = (id) => {
    if (gruposSelecionados.includes(id)) {
      setGruposSelecionados(gruposSelecionados.filter((gid) => gid !== id));
    } else {
      setGruposSelecionados([...gruposSelecionados, id]);
    }
  };

  const handleSelecionarTodosGrupos = () => {
    if (gruposSelecionados.length === gruposFiltrados.length) {
      setGruposSelecionados([]);
    } else {
      setGruposSelecionados(gruposFiltrados.map((g) => g.id));
    }
  };

  // Fundo WhatsApp (padrão de figuras)
  const whatsappBg = {
    backgroundImage: `url(${whatsappBgImg})`,
    backgroundRepeat: "repeat",
    backgroundSize: "auto",
    borderRadius: 12,
    minHeight: 320,
    height: 320,
    padding: 32,
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  };

  const notifyIconStyle = {
    background: notifyColor,
    color: "#fff",
    borderRadius: "50%",
    width: 32,
    height: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 16,
    margin: "0 8px 8px 0",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(81,161,151,0.10)",
    border: "none",
  };

  const BotaoProximo = ({ onClick, disabled }) => (
    <button
      style={{
        marginTop: 32,
        background: "#51a197",
        color: "#fff",
        border: "none",
        borderRadius: 8,
        padding: "12px 32px",
        fontWeight: "bold",
        fontSize: 17,
        cursor: disabled ? "not-allowed" : "pointer",
        alignSelf: "flex-end",
        opacity: disabled ? 0.6 : 1,
      }}
      onClick={onClick}
      disabled={disabled}
    >
      Próximo
    </button>
  );

  const [operacaoSelecionada, setOperacaoSelecionada] = useState(""); // Estado para armazenar a operação escolhida

  const conteudoEtapas = [
    // Etapa 1: Operação
    <Operacoes
      selected={selected}
      setSelected={setSelected}
      setEtapaAtual={setEtapaAtual}
      setOperacaoSelecionada={setOperacaoSelecionada}
    />,
    // Etapa 2: Conta conectada
    <ContasConectadas
      contasConectadas={contasConectadas}
      contasSelecionadas={contasSelecionadas}
      setContasSelecionadas={setContasSelecionadas}
      notifyColor={notifyColor}
      handleSelecionarConta={handleSelecionarConta}
      handleSelecionarTodas={handleSelecionarTodas}
      todasSelecionadas={todasSelecionadas}
      setEtapaAtual={setEtapaAtual}
      etapaAtual={etapaAtual}
    />,
    // Etapa 3: Grupos
    (
      <Grupos
        notifyColor={notifyColor}
        campanha={campanha}
        gruposFiltrados={gruposFiltrados}
        gruposSelecionados={gruposSelecionados}
        setGruposSelecionados={setGruposSelecionados}
        grupoPesquisa={grupoPesquisa}
        setGrupoPesquisa={setGrupoPesquisa}
        mostrarGrupos={mostrarGrupos}
        setMostrarGrupos={setMostrarGrupos}
        handleSelecionarGrupo={handleSelecionarGrupo}
        handleSelecionarTodosGrupos={handleSelecionarTodosGrupos}
        setEtapaAtual={setEtapaAtual}
        etapaAtual={etapaAtual}
      />

    ),

    // Etapa 4: Conteúdo
    selected === "nome" ? (
      <Mudanome
        notifyColor={notifyColor}
        onProximo={() => setEtapaAtual(5)}
      />
    ) : selected === "config" ? (
      <Mudaconfig
        notifyColor={notifyColor}
        onProximo={valorSelecionado => {
          const opcoes = [
            { value: 'admins_mensagens', label: 'Apenas admins enviam mensagens' },
            { value: 'todos_mensagens', label: 'Todos podem enviar mensagens' },
            { value: 'admins_config', label: 'Apenas admins mudam as configurações' },
            { value: 'todos_config', label: 'Todos podem mudar as configurações' },
          ];
          const selecionada = opcoes.find(opt => opt.value === valorSelecionado);
          setMensagens([{ tipo: "config", conteudo: selecionada ? selecionada.label : valorSelecionado }]);
          setEtapaAtual(5);
        }}
      />
    ) : selected === "adicionaradm" ? (
      <Adicionaradm
        onProximo={admin => {
          setMensagens([{ tipo: "texto", conteudo: `Administrador: ${admin.nome} - ${admin.numero}` }]);
          setEtapaAtual(5);
          // Sinalizar para a etapa de envio que é adicionar admin
          window._notifyTipoOperacao = 'Adicionar Administrador';
        }}
      />
    ) : (
      <Mensagem
        mensagens={mensagens}
        setMensagens={setMensagens}
        mensagem={mensagem}
        setMensagem={setMensagem}
        notifyColor={notifyColor}
        notifyIconStyle={notifyIconStyle}
        isMobile={isMobile}
        mencionarTodos={mencionarTodos}
        setMencionarTodos={setMencionarTodos}
        envioTemporario={envioTemporario}
        setEnvioTemporario={setEnvioTemporario}
        velocidade={velocidade}
        setVelocidade={setVelocidade}
        whatsappBg={whatsappBg}
        onValidacaoMensagem={setBotaoProximoHabilitado}
        setEtapaAtual={setEtapaAtual}
      />
    ),





    // Etapa 5: Resumo e Envio
    (
      <EtapaEnvio
        notifyColor={notifyColor}
        contasSelecionadas={contasSelecionadas}
        gruposSelecionados={gruposSelecionados}
        mensagens={mensagens.map(msg =>
          msg.tipo === 'config'
            ? {
              ...msg, conteudo: [
                { value: 'admins_mensagens', label: 'Apenas admins enviam mensagens' },
                { value: 'todos_mensagens', label: 'Todos podem enviar mensagens' },
                { value: 'admins_config', label: 'Apenas admins mudam as configurações' },
                { value: 'todos_config', label: 'Todos podem mudar as configurações' },
              ].find(opt => opt.label === msg.conteudo) ? msg.conteudo : [
                { value: 'admins_mensagens', label: 'Apenas admins enviam mensagens' },
                { value: 'todos_mensagens', label: 'Todos podem enviar mensagens' },
                { value: 'admins_config', label: 'Apenas admins mudam as configurações' },
                { value: 'todos_config', label: 'Todos podem mudar as configurações' },
              ].find(opt => opt.value === msg.conteudo)?.label || msg.conteudo
            }
            : msg
        )}
        novoNome={selected === 'nome' ? novoNome : ''}
      />
    ),
  ]; // <-- FECHA O ARRAY

  // Função para negrito com 1 asterisco
  function renderComNegrito(texto) {
    const partes = texto.split(/(\*[^\*]+\*)/g);
    return partes.map((parte, i) => {
      if (parte.startsWith("*") && parte.endsWith("*")) {
        return <b key={i}>{parte.slice(1, -1)}</b>;
      }
      return <React.Fragment key={i}>{parte}</React.Fragment>;
    });
  }

  // Modal de áudio
  const ModalAudio = () => (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.4)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 16,
          padding: 32,
          minWidth: 320,
          minHeight: 220,
          boxShadow: "0 2px 16px rgba(0,0,0,0.18)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 18,
        }}
      >
        {/* Ícone de microfone */}
        <FaMicrophone
          size={48}
          color={notifyColor}
          style={{ marginBottom: 8 }}
        />

        {/* Botão de upload de arquivo */}
        <label
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            cursor: "pointer",
            marginBottom: 8,
          }}
        >
          <FaUpload size={22} color={notifyColor} style={{ marginBottom: 4 }} />
          <span
            style={{
              color: notifyColor,
              fontWeight: "bold",
              fontSize: 15,
              marginBottom: 2,
            }}
          >
            Fazer upload de arquivo
          </span>
          <input
            type="file"
            accept="audio/mp3"
            onChange={handleUploadAudio}
            style={{ display: "none" }}
          />
        </label>

        {audioErro && <div style={{ color: "red" }}>{audioErro}</div>}

        {/* Botão para iniciar gravação */}
        {!gravandoAudio && !audioUrl && (
          <button
            onClick={iniciarGravacao}
            style={{
              background: notifyColor,
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding: "10px 32px",
              fontWeight: "bold",
              fontSize: 16,
              cursor: "pointer",
              marginTop: 8,
            }}
          >
            Gravar Áudio
          </button>
        )}

        {/* Gravação em andamento com contador */}
        {gravandoAudio && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 8,
            }}
          >
            <div
              style={{
                color: "#005c53",
                fontWeight: "bold",
                fontSize: 18,
              }}
            >
              Gravando... {tempoGravacao}s
            </div>
            <button
              onClick={pararGravacao}
              style={{
                background: "#e74c3c",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: "8px 24px",
                fontWeight: "bold",
                fontSize: 15,
                cursor: "pointer",
              }}
            >
              Parar Gravação
            </button>
          </div>
        )}

        {/* Preview do áudio gravado/upload */}
        {audioUrl && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 8,
            }}
          >
            <audio controls src={audioUrl} style={{ width: 220 }} />
            <button
              onClick={handleEnviarAudio}
              style={{
                background: notifyColor,
                color: "#fff",
                border: "none",
                borderRadius: 8,
                padding: "8px 24px",
                fontWeight: "bold",
                fontSize: 15,
                cursor: "pointer",
              }}
            >
              Usar este áudio
            </button>
          </div>
        )}

        <button
          onClick={fecharModalAudio}
          style={{
            marginTop: 12,
            background: "#e0e0e0",
            color: "#005c53",
            border: "none",
            borderRadius: 8,
            padding: "6px 18px",
            fontWeight: "bold",
            fontSize: 14,
            cursor: "pointer",
          }}
        >
          Fechar
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* MENU LATERAL */}
      <nav
        className={`d-flex flex-column flex-shrink-0 text-white${window.innerWidth <= 768 && sidebarOpen ? " menu-aberto" : ""
          }`}
        style={{
          width:
            window.innerWidth <= 768
              ? sidebarOpen
                ? "80vw"
                : 56
              : sidebarOpen
                ? 220
                : 70,
          maxWidth:
            window.innerWidth <= 768
              ? sidebarOpen
                ? 260
                : 56
              : sidebarOpen
                ? 220
                : 70,
          minWidth:
            window.innerWidth <= 768
              ? 56
              : sidebarOpen
                ? 220
                : 70,
          background: "#005c53",
          minHeight: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          zIndex: 3000,
          transition: "width 0.3s",
          alignItems: "center",
          boxShadow:
            window.innerWidth <= 768 && sidebarOpen
              ? "4px 0 16px rgba(0,0,0,0.18)"
              : "2px 0 8px rgba(0,0,0,0.10)",
          overflowX: "hidden",
          overflowY: "auto",
          scrollbarWidth: "thin",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: sidebarOpen ? "row" : "column",
            justifyContent: sidebarOpen ? "space-between" : "center",
            alignItems: "center",
            padding: sidebarOpen ? "16px 16px 8px 16px" : "24px 0 8px 0",
            transition: "all 0.3s",
            gap: sidebarOpen ? 12 : 8,
          }}
        >
          {sidebarOpen ? (
            <a href="/app">
              <img
                src={LogoCompleta}
                alt="Logo Completa"
                style={{
                  height: 40,
                  transition: "all 0.3s",
                }}
              />
            </a>
          ) : (
            <a href="/app">
              <img
                src={LogoIcone}
                alt="Logo Ícone"
                style={{
                  height: 32,
                  width: 32,
                  transition: "all 0.3s",
                }}
              />
            </a>
          )}
          <button
            onClick={() => setSidebarOpen((open) => !open)}
            className="btn btn-link text-white"
            style={{
              fontSize: 24,
              textDecoration: "none",
              boxShadow: "none",
              marginLeft: sidebarOpen ? 12 : 0,
              marginRight: 0,
              padding: 0,
              alignSelf: "center",
            }}
            title={sidebarOpen ? "Fechar menu" : "Abrir menu"}
          >
            <i className={`bi ${sidebarOpen ? "bi-x-lg" : "bi-list"}`}></i>
          </button>
        </div>
        <ul
          className="nav nav-pills flex-column mb-auto w-100"
          style={{
            alignItems: sidebarOpen ? "flex-start" : "center",
            gap: sidebarOpen ? 0 : -12,
            paddingBottom: 0,
          }}
        >
          <li className="nav-item w-100">
            <a
              href="/app"
              className="nav-link d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
                background: "#51a197",
                color: "#fff",
                fontWeight: "bold",
                borderRadius: 8,
                transition: "background 0.3s",
              }}
            >
              <i className="bi bi-speedometer2" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Dashboard</span>}
            </a>
          </li>
          <li>
            <hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} />
          </li>
          <li className="w-100">
            <a
              href="http://localhost:3000/Campanha"
              className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}
            >
              <i className="bi bi-megaphone" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Campanhas</span>}
            </a>
          </li>
          <li>
            <hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} />
          </li>
          <li className="w-100">
            <a
              href="http://localhost:3000/Projetos"
              className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}
            >
              <i className="bi bi-folder2-open" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Meus Projetos</span>}
            </a>
          </li>
          <li>
            <hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} />
          </li>
          <li className="w-100">
            <a
              href="http://localhost:3000/Contas"
              className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}
            >
              <i className="bi bi-person-lines-fill" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Contas</span>}
            </a>
          </li>
          <li>
            <hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} />
          </li>
          <li className="w-100">
            <a
              href="http://localhost:3000/Operacoes"
              className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}
            >
              <i className="bi bi-gear" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Operações</span>}
            </a>
          </li>
          <li>
            <hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} />
          </li>
          <li className="w-100">
            <a
              href="#"
              className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}
            >
              <i className="bi bi-send" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Disparo 1x1</span>}
            </a>
          </li>
          <li>
            <hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} />
          </li>
          <li className="w-100">
            <a
              href="#"
              className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}
            >
              <i className="bi bi-robot" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Automações</span>}
            </a>
          </li>
          <li>
            <hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} />
          </li>
        </ul>
      </nav>

      {/* CONTEÚDO PRINCIPAL */}
      <div
        style={{
          marginLeft: window.innerWidth <= 768 ? 56 : 70,
          width: window.innerWidth <= 768 ? "calc(100vw - 56px)" : "calc(100vw - 70px)",
          minHeight: "100vh",
          background: "#fff",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* HEADER */}
        <nav
          style={{
            width: "100%",
            height: 56,
            background: "#005c53",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            padding: "0 24px",
            position: "fixed", // Torna o header fixo
            top: 0,
            zIndex: 2000,
          }}
        >
          <span style={{ fontWeight: "bold", fontSize: 20 }}>Operação</span>
        </nav>

        {/* CONTEÚDO DAS ETAPAS */}
        <div
          style={{
            flex: 1,
            padding: "32px 24px",
            display: "flex",
            flexDirection: "column",
            gap: 24,
            background: "#f7f7f7",
            marginTop: 56, // Adiciona margem para compensar o header fixo
            position: "relative", // Adicionado para o botão "Próximo" funcionar corretamente
          }}
        >
          {/* Etapas da operação */}
          <div
            style={{
              display: "flex",
              gap: 6,
              marginBottom: 24,
              flexWrap: "wrap",
            }}
          >
            {etapas.map((etapa, idx) => {
              const isMobile = window.innerWidth <= 500;
              return (
                <div
                  key={idx}
                  style={{
                    padding: isMobile ? "5px 8px" : "8px 16px",
                    borderRadius: 16,
                    cursor: "pointer",
                    background: etapaAtual === idx + 1 ? notifyColor : "#e0e0e0",
                    color: etapaAtual === idx + 1 ? "#fff" : "#333",
                    fontWeight: etapaAtual === idx + 1 ? "bold" : "normal",
                    display: "flex",
                    alignItems: "center",
                    gap: isMobile ? 4 : 8,
                    transition: "background 0.2s, color 0.2s",
                    fontSize: isMobile ? 12 : 14,
                    minWidth: isMobile ? 0 : 80,
                  }}
                  onClick={() => setEtapaAtual(idx + 1)}
                >
                  <div
                    style={{
                      width: isMobile ? 18 : 24,
                      height: isMobile ? 18 : 24,
                      borderRadius: "50%",
                      background: etapaAtual === idx + 1 ? "#fff" : notifyColor,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: isMobile ? 11 : 14,
                      fontWeight: "bold",
                      color: etapaAtual === idx + 1 ? notifyColor : "#fff",
                    }}
                  >
                    {idx + 1}
                  </div>
                  <div style={{ fontSize: isMobile ? 11 : 14 }}>{etapa}</div>
                </div>
              );
            })}
          </div>

          {/* Conteúdo da etapa atual */}
          <div style={{ flex: 1 }}>
            {etapaAtual === 1 && (
              <Operacoes
                selected={selected}
                setSelected={setSelected}
                setEtapaAtual={setEtapaAtual}
                setOperacaoSelecionada={setOperacaoSelecionada} // Passa a função para definir a operação escolhida
              />
            )}

            {etapaAtual === 2 && (
              <ContasConectadas
                contasConectadas={contasConectadas}
                contasSelecionadas={contasSelecionadas}
                setContasSelecionadas={setContasSelecionadas}
                notifyColor={notifyColor}
                handleSelecionarConta={handleSelecionarConta}
                handleSelecionarTodas={handleSelecionarTodas}
                todasSelecionadas={todasSelecionadas}
                setEtapaAtual={setEtapaAtual}
                etapaAtual={etapaAtual}
              />
            )}

            {etapaAtual === 3 && (
              <Grupos
                notifyColor={notifyColor}
                campanha={campanha}
                gruposFiltrados={gruposFiltrados}
                gruposSelecionados={gruposSelecionados}
                setGruposSelecionados={setGruposSelecionados}
                grupoPesquisa={grupoPesquisa}
                setGrupoPesquisa={setGrupoPesquisa}
                mostrarGrupos={mostrarGrupos}
                setMostrarGrupos={setMostrarGrupos}
                handleSelecionarGrupo={handleSelecionarGrupo}
                handleSelecionarTodosGrupos={handleSelecionarTodosGrupos}
                setEtapaAtual={setEtapaAtual}
                etapaAtual={etapaAtual}
              />
            )}


            {etapaAtual === 4 && selected === "nome" && (
              <Mudanome
                notifyColor={notifyColor}
                novoNome={novoNome}
                setNovoNome={setNovoNome}
                onProximo={() => setEtapaAtual(5)}
              />
            )}

            {etapaAtual === 4 && selected === "descricao" && (
              <Mudadescricao
                onProximo={desc => {
                  // Salva a descrição como mensagem do tipo descricao
                  setMensagens([{ tipo: 'descricao', conteudo: desc }]);
                  setEtapaAtual(5);
                }}
              />
            )}

            {etapaAtual === 4 && selected === "imagem" && (
              <Mudaimagem
                onProximo={img => {
                  if (img) setMensagens([{ tipo: 'imagem', conteudo: img }]);
                  setEtapaAtual(5);
                }}
              />
            )}

            {etapaAtual === 4 && selected === "config" && (
              <Mudaconfig
                onProximo={valorSelecionado => {
                  const opcoes = [
                    { value: 'admins_mensagens', label: 'Apenas admins enviam mensagens' },
                    { value: 'todos_mensagens', label: 'Todos podem enviar mensagens' },
                    { value: 'admins_config', label: 'Apenas admins mudam as configurações' },
                    { value: 'todos_config', label: 'Todos podem mudar as configurações' },
                  ];
                  const selecionada = opcoes.find(opt => opt.value === valorSelecionado);
                  setMensagens([{ tipo: "config", conteudo: selecionada ? selecionada.label : valorSelecionado }]);
                  setEtapaAtual(5);
                }}
              />
            )}


            {etapaAtual === 4 && selected === "grupo" && (
              <Entrarnogrupo
                onProximo={() => setEtapaAtual(5)}
              />
            )}


            {etapaAtual === 4 && selected === "addadmin" && (
              <Adicionaradm
                onProximo={admin => {
                  if (admin && admin.nome && admin.numero) {
                    setMensagem(`Administrador: ${admin.nome} - ${admin.numero}`);
                    setMensagens([{ tipo: 'texto', conteudo: `Administrador: ${admin.nome} - ${admin.numero}` }]);
                  }
                  setEtapaAtual(5);
                }}
              />
            )}

            {etapaAtual === 4 && selected === "movecamp" && (
              <Movergrupos
                onProximo={grupos => {
                  setGruposSelecionados(grupos);
                  if (grupos && grupos[0] && grupos[0].nomeCampanha && grupos[0].nomeGrupo) {
                    setMensagens([
                      { tipo: 'texto', conteudo: `Grupo "${grupos[0].nomeGrupo}" foi movido para a campanha "${grupos[0].nomeCampanha}" com sucesso!` }
                    ]);
                  }
                  setEtapaAtual(5);
                }}
              />
            )}

            {etapaAtual === 4 && selected === "remadmin" && (
              <Removeradm
                onProximo={admin => {
                  const texto = `Administrador Removido: ${admin.nome} - ${admin.numero}`;
                  setMensagens([{ tipo: "texto", conteudo: texto }]);
                  setMensagem(texto);
                  window._notifyTipoOperacao = 'Remover Administrador';
                  setEtapaAtual(5);
                }}
              />
            )}

            {etapaAtual === 4 && selected === "remuser" && (
              <Removerparticipante
                onProximo={file => {
                  const texto = file && file.name ? `Remover participante: ${file.name}` : 'Remover participante';
                  setMensagens([{ tipo: "texto", conteudo: texto }]);
                  setMensagem(texto);
                  window._notifyTipoOperacao = 'Remover Participante';
                  setEtapaAtual(5);
                }}
              />
            )}

            {etapaAtual === 4 && selected !== "nome" && selected !== "descricao" && selected !== "imagem" && selected !== "config" && selected !== "grupo" && selected !== "addadmin" && selected !== "remadmin" && selected !== "remuser" && selected !== "movecamp" && (
              <Mensagem
                mensagens={mensagens}
                setMensagens={setMensagens}
                mensagem={mensagem}
                setMensagem={setMensagem}
                notifyColor={notifyColor}
                notifyIconStyle={notifyIconStyle}
                isMobile={isMobile}
                mencionarTodos={mencionarTodos}
                setMencionarTodos={setMencionarTodos}
                envioTemporario={envioTemporario}
                setEnvioTemporario={setEnvioTemporario}
                velocidade={velocidade}
                setVelocidade={setVelocidade}
                whatsappBg={whatsappBg}
                onValidacaoMensagem={setBotaoProximoHabilitado}
                setEtapaAtual={setEtapaAtual}
              />
            )}

            {etapaAtual === 5 && (
              <EtapaEnvio
                notifyColor={notifyColor}
                contasSelecionadas={contasSelecionadas}
                gruposSelecionados={gruposSelecionados}
                mensagens={mensagens}
                mensagem={mensagem}
                mencionarTodos={mencionarTodos}
                novoNome={novoNome}
              />
            )}
          </div>
        </div>
      </div>
      {modalAudioAberto && <ModalAudio />}
      {/* Botão Próximo - Aparece apenas na etapa de Mensagem */}
      {etapaAtual === 4 && (
        <div
          style={{
            position: "absolute",
            top: 16,
            right: 16,
            zIndex: 1000,
          }}
        >
          <button
            onClick={() => setEtapaAtual(etapaAtual + 1)}
            disabled={!mensagem.trim() || gruposSelecionados.length === 0} // Desabilita o botão se as condições não forem atendidas
            style={{
              background: !mensagem.trim() || gruposSelecionados.length === 0 ? "#ccc" : "#51a197",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding: "8px 16px",
              fontWeight: "bold",
              fontSize: 16,
              cursor: !mensagem.trim() || gruposSelecionados.length === 0 ? "not-allowed" : "pointer",
              opacity: !mensagem.trim() || gruposSelecionados.length === 0 ? 0.6 : 1,
              transition: "background 0.2s",
            }}
          >
            Próximo
          </button>
        </div>
      )}
    </div>
  );
};

export default AdicionarOperacao;
